import { ElementRef, InjectionToken } from '@angular/core';

// ä¸ææ¡å³è¾¹ç®­å¤´ç className æ³¨å¥ key
export const UI_DROPDOWN_ARROW_CLASSNAME = new InjectionToken<string>('UI_DROPDOWN_ARROW_CLASSNAME');

export abstract class DropdownRenderer {
  abstract renderDropdown(ref: ElementRef): () => void;
}

